import axios from "../utils/request";

/**
 * 路径地址
 */
const base = {
  // baseUrl: 'http://cdz.test.jsxhykj.cn/api/cdz',
  // baseUrl: 'http://10.0.0.21:9080/api/cdz',
  baseUrl: '/api/cdz',
  login: '/account/login',
  logout: '/account/logout',
  current: '/account/current',
  sendSmsCode: '/account/sendSmsCode',
  wechatBindMobile: '/wechat/bind/mobile',
  wechatOauth2url: '/wechat/oauth2/url',
  wechatOauth2CodeToAccessToken: '/wechat/oauth2/codeToAccessToken',
  wechatJsapiSignature: '/wechat/jsapiSignature',
  deviceQueryByQrcode: '/device/queryByQrcode',
  deviceQueryOrderPrice: '/order/device/price',
  orderPayChannel: '/order/pay/channel',
  orderCreate: '/order/create',
  orderCancel: '/order/cancel',
  orderPay: '/order/pay',
  userOrderDetail: '/order/user/detail',
  userOrderList: '/order/user/list',
  userOrderPowerList: '/order/user/power/list',
  userOrderStop: '/order/user/stop',
  userIllegalRecordList: '/settings/illegalRecord/user/list',
  userCardList: '/card/user/list',
  userCardDetail: '/card/user/detail',
  userCardBind: '/card/user/bind',
  userWalletDetail: '/wallet/user/detail',
  userWalletFlowList: '/wallet/user/flow/list',
  userWalletRecharge: '/wallet/user/recharge',
  orderDashboardData: '/order/dashboard/house/member/summary',
  alipayAppId: '/alipay/appid',
  alipayAuthRedirect: '/alipay/authRedirect',
  alipayBindMobile: '/alipay/bind/mobile',
};

/**
 * 请求方法
 */
const api = {
  /**
   * 登陆接口
   */
  login(parms) {
    return axios.post(base.baseUrl + base.login, parms);
  },
  /**
   * 退出接口
   */
  logout(parms) {
    return axios.post(base.baseUrl + base.logout, parms);
  },
  /**
   * 当前登陆用户信息接口
   */
  current() {
    return axios.get(base.baseUrl + base.current);
  },
  /**
   * 发送短信验证码
   */
  sendSmsCode(parms) {
    return axios.post(base.baseUrl + base.sendSmsCode, parms);
  },
  /**
   * 获取微信网页授权url
   */
  wechatOauth2url() {
    return axios.get(base.baseUrl + base.wechatOauth2url);
  },
  /**
   * 微信网页授权code换token
   */
  wechatOauth2CodeToAccessToken(params) {
    return axios.get(base.baseUrl + base.wechatOauth2CodeToAccessToken, { params });
  },
  /**
   * 微信OpenId绑定手机号
   */
  wechatBindMobile(params) {
    return axios.post(base.baseUrl + base.wechatBindMobile, params);
  },
  /**
   * 微信获取jsapiSignature
   */
  wechatJsapiSignature(params) {
    return axios.post(base.baseUrl + base.wechatJsapiSignature, params);
  },
  /**
   * 设备 根据qrcode获取设备信息
   */
  deviceQueryByQrcode(params) {
    return axios.post(base.baseUrl + base.deviceQueryByQrcode, params);
  },
  /**
   * 获取设备价格列表
   */
  deviceQueryOrderPrice(params) {
    return axios.post(base.baseUrl + base.deviceQueryOrderPrice, params);
  },
  /**
   * 获取支付渠道
   */
  orderPayChannel() {
    return axios.get(base.baseUrl + base.orderPayChannel);
  },
  /**
   * 创建订单
   */
  orderCreate(params) {
    return axios.post(base.baseUrl + base.orderCreate, params);
  },
  /**
   * 取消订单
   */
  orderCancel(params) {
    return axios.post(base.baseUrl + base.orderCancel, params);
  },
  /**
   * 获取订单第三方支付参数
   */
  orderPay(params) {
    return axios.post(base.baseUrl + base.orderPay, params);
  },
  /**
   * 获取用户订单信息
   */
  userOrderDetail(params) {
    return axios.get(base.baseUrl + base.userOrderDetail, { params });
  },
  /**
   * 提前取消订单
   */
  userOrderStop(params) {
    return axios.post(base.baseUrl + base.userOrderStop, params);
  },
  /**
   * 获取用户订单列表
   */
  userOrderList(params) {
    return axios.post(base.baseUrl + base.userOrderList, params);
  },
  /**
   * 获取用户充电功率列表
   */
  userOrderPowerList(params) {
    return axios.get(base.baseUrl + base.userOrderPowerList, { params });
  },
  /**
   * 获取用户违规记录列表
   */
  userIllegalRecordList(params) {
    return axios.post(base.baseUrl + base.userIllegalRecordList, params);
  },
  /**
   * 获取用户IC卡信息
   */
  userCardDetail(params) {
    return axios.get(base.baseUrl + base.userCardDetail, { params });
  },
  /**
   * 获取用户IC卡列表
   */
  userCardList() {
    return axios.get(base.baseUrl + base.userCardList);
  },
  /**
   * 获取用户IC卡绑定
   */
  userCardBind(params) {
    return axios.post(base.baseUrl + base.userCardBind, params);
  },
  /**
   * 获取用户钱包信息
   */
  userWalletDetail(params) {
    return axios.get(base.baseUrl + base.userWalletDetail, { params });
  },
  /**
   * 获取用户钱包明细
   */
  userWalletFlowList(params) {
    return axios.post(base.baseUrl + base.userWalletFlowList, params);
  },
  /**
   * 用户钱包充值
   */
  userWalletRecharge(params) {
    return axios.post(base.baseUrl + base.userWalletRecharge, params);
  },
  /**
   * 订单数据统计
   */
  orderDashboardData() {
    return axios.get(base.baseUrl + base.orderDashboardData);
  },
  /**
   * 支付宝AppId
   */
  alipayAppId() {
    return axios.get(base.baseUrl + base.alipayAppId);
  },
  /**
   * 支付宝AuthCode换取用户信息
   */
  alipayAuthRedirect(params) {
    return axios.get(base.baseUrl + base.alipayAuthRedirect, { params });
  },
  /**
   * 支付宝AlipayUserId绑定手机号
   */
  alipayBindMobile(params) {
    return axios.post(base.baseUrl + base.alipayBindMobile, params);
  },
};

export default api;